import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/contactUs/kf-ico1.png'
import _imports_1 from '../assets/img/contactUs/kf-ico2.png'
import _imports_2 from '../assets/img/contactUs/toright.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-21a0fbaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"infobox\" data-v-21a0fbaf><div class=\"info-text1\" data-v-21a0fbaf>客服咨询</div><div class=\"info-row\" data-v-21a0fbaf><img src=\"" + _imports_0 + "\" alt=\"\" class=\"kf-ico1\" data-v-21a0fbaf><div class=\"dhbox\" data-v-21a0fbaf><div class=\"info-text2\" data-v-21a0fbaf>电话热线</div><div class=\"info-text3\" data-v-21a0fbaf>400 666 6011</div></div></div><div class=\"kbbox\" data-v-21a0fbaf></div><div class=\"info-text1\" data-v-21a0fbaf>技术咨询</div><div class=\"info-row\" data-v-21a0fbaf><img src=\"" + _imports_1 + "\" alt=\"\" class=\"kf-ico1\" data-v-21a0fbaf><div class=\"dhbox\" data-v-21a0fbaf><div class=\"info-text2\" data-v-21a0fbaf>许经理</div><div class=\"info-text3\" data-v-21a0fbaf>1590 126 5905</div></div></div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"toright\" data-v-21a0fbaf><div class=\"content\" data-v-21a0fbaf></div>", 3)
const _hoisted_4 = [
  _hoisted_1
]

import { reactive, toRefs, ref} from 'vue' 


export default /*#__PURE__*/_defineComponent({
  __name: 'contactUs',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_4))
}
}

})